export default __webpack_public_path__ + "lg.svg?537984e3f831fdf11f619668c5d5ab3b";